module.exports = __webpack_public_path__ + "static/img/logo.d44a686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo.png
// module id = vJvE
// module chunks = 1